import { useMemo } from 'react';
import './GameHUD.css';

/**
 * Unified Game HUD: Timer (circular), Score, Passes
 */
export const GameHUD = ({
  timeLeft,
  totalTime = 60,
  score,
  passesLeft,
  totalPasses = 3,
  onExit,
}) => {
  const progress = totalTime > 0 ? timeLeft / totalTime : 0;
  const isUrgent = timeLeft <= 10;
  const isWarning = timeLeft <= 20 && !isUrgent;

  // SVG circle params
  const R = 22;
  const C = 2 * Math.PI * R;
  const dashOffset = C * (1 - progress);

  const timerClass = isUrgent ? 'hud-timer--urgent' : isWarning ? 'hud-timer--warning' : '';

  const passDots = useMemo(
    () => Array.from({ length: totalPasses }, (_, i) => i < passesLeft),
    [passesLeft, totalPasses],
  );

  return (
    <div className="game-hud">
      {/* Exit Button */}
      {onExit ? (
        <button className="hud-exit" onClick={onExit} aria-label="Esci">
          ESCI
        </button>
      ) : null}

      {/* Score */}
      <div className="hud-score">
        <span className="hud-score__value">{score}</span>
        <span className="hud-score__label">PUNTI</span>
      </div>

      {/* Timer Circle */}
      <div className={`hud-timer ${timerClass}`}>
        <svg viewBox="0 0 56 56" className="hud-timer__ring">
          <circle
            cx="28"
            cy="28"
            r={R}
            fill="none"
            stroke="rgba(255,255,255,0.08)"
            strokeWidth="4"
          />
          <circle
            cx="28"
            cy="28"
            r={R}
            fill="none"
            stroke="currentColor"
            strokeWidth="4"
            strokeLinecap="round"
            strokeDasharray={C}
            strokeDashoffset={dashOffset}
            transform="rotate(-90 28 28)"
            style={{ transition: 'stroke-dashoffset 0.9s linear' }}
          />
        </svg>
        <span className="hud-timer__value">{timeLeft}</span>
      </div>

      {/* Passes */}
      <div className="hud-passes">
        <div className="hud-passes__dots">
          {passDots.map((active, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <span key={i} className={`hud-dot ${active ? 'hud-dot--active' : 'hud-dot--used'}`} />
          ))}
        </div>
        <span className="hud-passes__label">PASSI</span>
      </div>
    </div>
  );
};
